// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Package/components/ProductBanner/index.css
// module id = 2290
// module chunks = 0